<template>
  <v-data-table :items="items" :loading="loading" hide-actions>
    <template v-slot:headers>
      <tr class="headerRow grey lighten-3">
        <th>クリエイティブ名</th>
        <th>ステータス</th>
      </tr>
    </template>
    <template v-slot:items="{ item }">
      <tr
        @click="$emit('select', item)"
        @dblclick.stop="$emit('perform', item)"
        :class="{ 'blue lighten-2 white--text': isSelected(item) }"
        class="itemRow"
      >
        <td class="text-no-wrap">
          <v-icon v-text="icon(item)" :class="iconStyles(item)"></v-icon>
          <span class="creativeName">{{ item.name }}</span>
        </td>
        <td>
          <AppStatus :value="item.status" readonly with-icon />
        </td>
      </tr>
    </template>
    <template slot="no-data">
      <td colspan="2">
        <div v-text="emptyText" class="text-xs-center" />
      </td>
    </template>
  </v-data-table>
</template>

<script>
import { css } from 'emotion'

export default {
  name: 'CampaignModalPageCreativeSelectorCreativeTable',
  props: {
    items: {
      type: Array,
      required: true,
    },
    selectedItems: {
      type: Array,
      required: true,
    },
    loading: Boolean,
    emptyText: {
      type: String,
      default: '表示できるクリエイティブがありません。',
    },
  },
  computed: {
    headers() {
      return ['クリエイティブ名', 'ステータス'].map(text => ({
        text,
        sortable: false,
      }))
    },
  },
  methods: {
    isSelected(item) {
      return this.selectedItems.find(i => i.id === item.id) != null
    },
    icon(item) {
      if (item.hasWarning) {
        return 'warning'
      } else if (item.hasNotice) {
        return 'information'
      } else {
        return ''
      }
    },
    iconStyles(item) {
      return [
        css`
          width: 30px;
        `,
        {
          'yellow--text text--darken-2': item.hasWarning,
          'info--text text--lighten-1': !item.hasWarning && item.hasNotice,
        },
      ]
    },
  },
}
</script>

<style scoped lang="scss">
.headerRow {
  height: 24px;

  th {
    padding: 0 8px !important;
  }
}

.itemRow {
  cursor: pointer;
  user-select: none;

  td {
    padding: 0 8px !important;
  }
}

.creativeName {
  display: inline-block;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
